module.exports = __webpack_public_path__ + "static/media/ic_remove.7c64aaab.svg";